import { render, staticRenderFns } from "./card-stat.vue?vue&type=template&id=5795ff40&scoped=true&"
import script from "./card-stat.vue?vue&type=script&lang=js&"
export * from "./card-stat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5795ff40",
  null
  
)

export default component.exports